import React, { useState } from "react";
import { BubbleMenu } from "@tiptap/react/menus";
import Tooltip from "@mui/material/Tooltip";
// import { Paragraph } from '@tiptap/core';
import Highlight from "@tiptap/extension-highlight"; // <-- 1. IMPORT IT

const CustomBubbleMenu = ({ editor, addImage, containerRef, className, shouldShow }) => {
  const [isHighlightMenuOpen, setIsHighlightMenuOpen] = useState(false);

  // const addImage = useCallback(() => {
  //   const url = window.prompt('URL')

  //   if (url) {
  //     editor.chain().focus().setImage({ src: url }).run()
  //   }
  // }, [editor])

  // if (!editor) {
  //   return null;

  // }

  return (
    <BubbleMenu className={`bubble-menu ${className || ""}`} editor={editor} shouldShow={shouldShow}>

        <Tooltip title="Highlight">
        <div style={{ position: "relative"}}>
          <button style={{backgroundColor: "#ffe1beAA"}} onClick={() => setIsHighlightMenuOpen(!isHighlightMenuOpen)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.94002 1.74512C8.69797 1.74512 8.47469 1.87466 8.35451 2.08432L4.87211 8.12098C4.37352 8.98517 4.67439 10.1119 5.53944 10.6113L5.94939 10.8482L4.30792 13.694H4.30706C4.12042 14.017 4.23036 14.4303 4.55337 14.6178L5.58633 15.2144L2.05527 21.3364H2.05442C1.93425 21.5452 1.9334 21.8034 2.05357 22.0123C2.17459 22.2219 2.39703 22.3515 2.63908 22.3515H9.40359C9.64479 22.3506 9.86808 22.2211 9.98825 22.0123L11.8317 18.8214L12.863 19.4171C13.0181 19.5066 13.203 19.5313 13.376 19.4844C13.5499 19.4384 13.6974 19.3242 13.7868 19.1691L15.4292 16.3233L15.84 16.5603C16.705 17.0597 17.83 16.758 18.3294 15.8929L21.8118 9.85541L21.811 9.85456C21.9959 9.53324 21.8868 9.1216 21.5664 8.9341L9.27835 1.83555C9.17523 1.77674 9.0585 1.74512 8.94002 1.74512ZM9.18633 3.3474L20.3025 9.76675L17.1567 15.2169C17.0212 15.453 16.751 15.5263 16.5158 15.3908L15.5383 14.8257V14.8249C15.5323 14.8215 15.5263 14.8181 15.5204 14.8147L7.20981 10.0155H7.21067C7.19788 10.0079 7.1851 10.001 7.17231 9.99508L6.21522 9.44195C5.97914 9.30558 5.90413 9.03371 6.0405 8.79763L9.18633 3.3474ZM7.11871 11.5266L14.2565 15.6483L12.9534 17.9069L11.9273 17.3146L11.9281 17.3137V17.3129V17.3103L6.85451 14.381V14.3776L5.82838 13.7853L7.11871 11.5266ZM6.75648 15.8929L9.44972 17.4465L10.6565 18.1437L9.01248 20.9971H3.81103L6.75648 15.8929ZM11.807 20.9972H11.8078C11.4345 20.9972 11.1319 21.2998 11.1319 21.6731C11.1311 21.8529 11.2018 22.0251 11.3288 22.1529C11.4558 22.2799 11.628 22.3515 11.8078 22.3515H18.8254C19.0052 22.3515 19.1774 22.2799 19.3044 22.1529C19.4314 22.0251 19.5021 21.8529 19.5012 21.6731C19.5012 21.2998 19.1987 20.9972 18.8254 20.9972H11.807Z" fill="black"/>
            </svg>
          </button>
          {isHighlightMenuOpen && (
            <div
              style={{
                maxWidth: "180px",
                position: "absolute",
                top: "40px",
                borderRadius: "12px",
                left: "-6px",
                background: "var(--Grey2)",
                padding: "8px",
                zIndex: 1,
                display: "wrap",
                flexDirection: "column",
                boxShadow: "0 4px 6px var(--Shadow)"

              }}
            >
              {/* <p>Highlight</p> */}
              <button
              id="highlight-new-idea"
                style={{display: "flex", alignItems: "left", flexDirection: "row", gap: "4px"  }}
                onClick={() => {
                  editor.chain().focus().toggleHighlight({ color: "rgba(255, 192, 120, 0.3)", id: "highlight-new-idea" }).run();
                  setIsHighlightMenuOpen(false);
                }}
                className={editor.isActive("highlight", { color: "rgba(255, 192, 120, 0.3)" }) ? "is-active" : ""}
              >
                <div className="highlight-box" style={{ flexStretch: "1", backgroundColor: "#ffe1beff" }}>  </div> <p className="highlight-label">New Idea</p>
              </button>
              <button
              id="highlight-success"
                style={{display: "flex", alignItems: "left", flexDirection: "row", gap: "4px"  }}
                onClick={() => {
                  editor.chain().focus().toggleHighlight({ color: "rgba(140, 233, 154, 0.30)", id: "highlight-success" }).run();
                  setIsHighlightMenuOpen(false);
                }}
                className={editor.isActive("highlight", { color: "rgba(140, 233, 154, 0.30)" }) ? "is-active" : ""}
              >
                <div className="highlight-box" style={{ backgroundColor: "#bcecc3ff" }}> </div> <p className="highlight-label">Success</p>
              </button>
              <button
              id="highlight-happy-path"
                style={{display: "flex", alignItems: "left", flexDirection: "row", gap: "4px" }}
                onClick={() => {
                  editor.chain().focus().toggleHighlight({ color: "rgba(116, 192, 252, 0.30)", id: "highlight-happy-path" }).run();
                  setIsHighlightMenuOpen(false);
                }}
                className={editor.isActive("highlight", { color: "rgba(116, 192, 252, 0.30)" }) ? "is-active" : ""}
              >
                <div className="highlight-box" style={{ backgroundColor: "#c4e4fdff" }}> </div> <p className="highlight-label">Happy path</p>
              </button>
              {/* <br></br> */}
              <button
              id="highlight-unclear"
                style={{display: "flex", alignItems: "left", flexDirection: "row", gap: "4px"  }}
                onClick={() => {
                  editor.chain().focus().toggleHighlight({ color: "rgba(177, 151, 252, 0.30)", id: "highlight-unclear"  }).run();
                  setIsHighlightMenuOpen(false);
                }}
                className={editor.isActive("highlight", { color: "rgba(177, 151, 252, 0.30)"}) ? "is-active" : ""}
              >
                <div className="highlight-box" style={{ backgroundColor: "#d6caf9ff" }}> </div> <p className="highlight-label">Unclear</p>
              </button>
              <button
              id="highlight-pain-point"
                style={{display: "flex", alignItems: "left", flexDirection: "row", gap: "4px"  }}
                onClick={() => {
                  editor.chain().focus().toggleHighlight({ color: "rgba(255, 168, 168, 0.30)", id: "highlight-pain-point" }).run();
                  setIsHighlightMenuOpen(false);
                }}
                className={editor.isActive("highlight", { color: "rgba(255, 168, 168, 0.30)" }) ? "is-active" : ""}
              >
                <div className="highlight-box" style={{ backgroundColor: "#fbcbcbff" }}> </div> <p className="highlight-label">Pain point</p>
              </button>
              <button
              id="highlight-remove"
              style={{display: "flex", alignItems: "left", flexDirection: "row", gap: "4px" }}
                onClick={() => {
                  editor.chain().focus().unsetHighlight().run();
                  setIsHighlightMenuOpen(false);
                }}
                disabled={!editor.isActive("highlight")}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    backgroundColor: "var(--Grey1)",
                    border: "solid 1px var(--Grey5)",
                    borderRadius: "4px",
                    margin: "4px",
                    
                  }}
                ></div> <p className="highlight-label"> Remove </p>
              </button>
            </div>
          )}
        </div>
      </Tooltip>

      {/* <Tooltip title="Blue Text">
        <button
          onClick={() => {
            if (editor.isActive("textStyle", { color: "#22aecd" })) {
              editor.chain().focus().unsetMark("textStyle").run();
            } else {
              editor.chain().focus().setColor("#22aecd").run();
              // addImage();
            }
          }}
          className={editor.isActive("textStyle", { color: "#22aecd" }) ? "is-active" : ""}
        >
          <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="paint-tool" width={22} height={22}>
            <path
              fill="var(--Grey7)"
              d="M18,1H10A3,3,0,0,0,7,4H6A3,3,0,0,0,3,7v3a3,3,0,0,0,3,3h6a1,1,0,0,1,1,1v1a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V17a2,2,0,0,0-2-2V14a3,3,0,0,0-3-3H6a1,1,0,0,1-1-1V7A1,1,0,0,1,6,6H7a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V4A3,3,0,0,0,18,1ZM15,17v4H13V17ZM19,6a1,1,0,0,1-1,1H10A1,1,0,0,1,9,6V4a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1Z"
            ></path>
          </svg>
        </button>
      </Tooltip> */}


      <Tooltip title="Text Style">
        <select
          style={{
            color: "var(--Grey7)",
            backgroundColor: "var(--Grey2)",
            height: "32px",
            borderRadius: "4px",
            hover: { cursor: "pointer", borderColor: "var(--Grey4)" },
          }}
          onChange={(e) => {
            const value = e.target.value; // Get the raw value ('', '1', '2', '3')
            const level = parseInt(value, 10); // Attempt to parse it

            const chain = editor.chain().focus(); // Start the chain

            // Check if level is a valid number between 1 and 3 (inclusive)
            if (!isNaN(level) && level >= 1 && level <= 5) {
              // Tiptap headings go up to 6
              // It's a heading level
              chain.toggleHeading({ level }); // Use toggleHeading
            } else {
              // It's the Paragraph option (value was '' or invalid)
              chain.setParagraph(); // Set as paragraph
            }

            chain.run(); // Execute the chosen command
          }}
          value={editor.isActive("heading") ? editor.getAttributes("heading").level : ""}
        >
          <option value="1">Heading 1</option>
          <option value="2">Heading 2</option>
          <option value="3">Heading 3</option>
          <option value="">Paragraph</option>

          {/* You can add H4, H5, H6 if needed */}
        </select>
      </Tooltip>

      <Tooltip title="Bold">
        <span>
          <button
            onClick={() => editor.chain().focus().toggleBold().run()}
            disabled={!editor.can().chain().focus().toggleBold().run()}
            className={editor.isActive("bold") ? "is-active" : ""}
          >
            <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="bold" height={24} width={24}>
              <path
                fill="var(--Grey7)"
                d="M16.5,9.5A3.5,3.5,0,0,0,13,6H8.5a1,1,0,0,0-1,1V17a1,1,0,0,0,1,1H13a3.49,3.49,0,0,0,2.44-6A3.5,3.5,0,0,0,16.5,9.5ZM13,16H9.5V13H13a1.5,1.5,0,0,1,0,3Zm0-5H9.5V8H13a1.5,1.5,0,0,1,0,3Z"
              ></path>
            </svg>
          </button>
        </span>
      </Tooltip>
      <Tooltip title="Italic">
        <span>
          <button
            onClick={() => editor.chain().focus().toggleItalic().run()}
            disabled={!editor.can().chain().focus().toggleItalic().run()}
            className={editor.isActive("italic") ? "is-active" : ""}
          >
            <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="italic" height={24} width={24}>
              <path fill="var(--Grey7)" d="M17,6H11a1,1,0,0,0,0,2h1.52l-3.2,8H7a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H11.48l3.2-8H17a1,1,0,0,0,0-2Z"></path>
            </svg>
          </button>
        </span>
      </Tooltip>
      <Tooltip title="Strike-Through">
        <span>
          <button
            onClick={() => editor.chain().focus().toggleStrike().run()}
            disabled={!editor.can().chain().focus().toggleStrike().run()}
            className={editor.isActive("strike") ? "is-active" : ""}
          >
            <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="text-strike-through" height={24} width={24}>
              <path
                fill="var(--Grey7)"
                d="M15,13H9a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0V15h2a1,1,0,0,0,0-2Zm2-7H7A1,1,0,0,0,7,8h4v2a1,1,0,0,0,2,0V8h4a1,1,0,0,0,0-2Z"
              ></path>
            </svg>
          </button>
        </span>
      </Tooltip>
      <Tooltip title="To-do List">
        <button onClick={() => editor.chain().focus().toggleTaskList().run()} className={editor.isActive("bulletList") ? "is-active" : ""}>
          <svg width="24px" height="24px" viewBox="0 0 24 24" fill="var(--Grey7)" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.25 8.5C12.8358 8.5 12.5 8.83579 12.5 9.25C12.5 9.66421 12.8358 10 13.25 10H16.75C17.1642 10 17.5 9.66421 17.5 9.25C17.5 8.83579 17.1642 8.5 16.75 8.5H13.25Z"
              fill="var(--Grey7)"
            />
            <path
              d="M12.5001 14.75C12.5001 14.3358 12.8358 14 13.2501 14H16.7499C17.1642 14 17.4999 14.3358 17.4999 14.75C17.4999 15.1642 17.1642 15.5 16.7499 15.5H13.2501C12.8358 15.5 12.5001 15.1642 12.5001 14.75Z"
              fill="var(--Grey7)"
            />
            <path
              d="M10.7803 7.71967C11.0732 8.01256 11.0732 8.48744 10.7803 8.78033L8.78033 10.7803C8.48744 11.0732 8.01256 11.0732 7.71967 10.7803L6.71967 9.78033C6.42678 9.48744 6.42678 9.01256 6.71967 8.71967C7.01256 8.42678 7.48744 8.42678 7.78033 8.71967L8.25 9.18934L9.71967 7.71967C10.0126 7.42678 10.4874 7.42678 10.7803 7.71967Z"
              fill="var(--Grey7)"
            />
            <path
              d="M10.7803 14.2803C11.0732 13.9874 11.0732 13.5126 10.7803 13.2197C10.4874 12.9268 10.0126 12.9268 9.71967 13.2197L8.25 14.6893L7.78033 14.2197C7.48744 13.9268 7.01256 13.9268 6.71967 14.2197C6.42678 14.5126 6.42678 14.9874 6.71967 15.2803L7.71967 16.2803C8.01256 16.5732 8.48744 16.5732 8.78033 16.2803L10.7803 14.2803Z"
              fill="var(--Grey7)"
            />
            <path
              d="M5.25 3C4.00736 3 3 4.00736 3 5.25V18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V5.25C21 4.00736 19.9926 3 18.75 3H5.25ZM4.5 5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H18.75C19.1642 4.5 19.5 4.83579 19.5 5.25V18.75C19.5 19.1642 19.1642 19.5 18.75 19.5H5.25C4.83579 19.5 4.5 19.1642 4.5 18.75V5.25Z"
              fill="var(--Grey7)"
            />
          </svg>
        </button>
      </Tooltip>
      <Tooltip title="Bullet List">
        <button onClick={() => editor.chain().focus().toggleBulletList().run()} className={editor.isActive("bulletList") ? "is-active" : ""}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="list-ul" width={24} height={24}>
            <path
              fill="var(--Grey7)"
              d="M3.71,16.29a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21,1,1,0,0,0-.21.33,1,1,0,0,0,.21,1.09,1.15,1.15,0,0,0,.33.21.94.94,0,0,0,.76,0,1.15,1.15,0,0,0,.33-.21,1,1,0,0,0,.21-1.09A1,1,0,0,0,3.71,16.29ZM7,8H21a1,1,0,0,0,0-2H7A1,1,0,0,0,7,8ZM3.71,11.29a1,1,0,0,0-1.09-.21,1.15,1.15,0,0,0-.33.21,1,1,0,0,0-.21.33.94.94,0,0,0,0,.76,1.15,1.15,0,0,0,.21.33,1.15,1.15,0,0,0,.33.21.94.94,0,0,0,.76,0,1.15,1.15,0,0,0,.33-.21,1.15,1.15,0,0,0,.21-.33.94.94,0,0,0,0-.76A1,1,0,0,0,3.71,11.29ZM21,11H7a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2ZM3.71,6.29a1,1,0,0,0-.33-.21,1,1,0,0,0-1.09.21,1.15,1.15,0,0,0-.21.33.94.94,0,0,0,0,.76,1.15,1.15,0,0,0,.21.33,1.15,1.15,0,0,0,.33.21,1,1,0,0,0,1.09-.21,1.15,1.15,0,0,0,.21-.33.94.94,0,0,0,0-.76A1.15,1.15,0,0,0,3.71,6.29ZM21,16H7a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
            ></path>
          </svg>
        </button>
      </Tooltip>
      <Tooltip title="Numbered List">
        <button onClick={() => editor.chain().focus().toggleOrderedList().run()} className={editor.isActive("orderedList") ? "is-active" : ""}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="list-ol" width={24} height={24}>
            <path
              fill="var(--Grey7)"
              d="M7 20H4v-.1c0-.5.4-.9.9-.9 1.4 0 2.6-.9 3-2.2.4-1.6-.5-3.3-2.1-3.7-1.3-.4-2.7.2-3.4 1.4-.3.5-.1 1.1.4 1.4.5.3 1.1.1 1.4-.4.3-.5.9-.6 1.4-.3.1.1.2.1.2.2.2.3.2.6.2.9-.2.4-.6.7-1 .7-1.7 0-3 1.3-3 2.9V21c0 .6.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zm4-13h10c.6 0 1-.4 1-1s-.4-1-1-1H11c-.6 0-1 .4-1 1s.4 1 1 1zM7 9H6V3c0-.6-.4-1-1-1s-1 .4-1 1v1H3c-.6 0-1 .4-1 1s.4 1 1 1h1v3H3c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zm14 7H11c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1z"
            ></path>
          </svg>
        </button>
      </Tooltip>
      <Tooltip title="Code Block">
        <button onClick={() => editor.chain().focus().toggleCodeBlock().run()} className={editor.isActive("codeBlock") ? "is-active" : ""}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="arrow" height={24} width={24}>
            <path
              fill="var(--Grey7)"
              d="M9.71,6.29a1,1,0,0,0-1.42,0l-5,5a1,1,0,0,0,0,1.42l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L5.41,12l4.3-4.29A1,1,0,0,0,9.71,6.29Zm11,5-5-5a1,1,0,0,0-1.42,1.42L18.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5A1,1,0,0,0,20.71,11.29Z"
            ></path>
          </svg>
        </button>
      </Tooltip>
      <Tooltip title="Blockqoute">
        <button onClick={() => editor.chain().focus().toggleBlockquote().run()} className={editor.isActive("blockquote") ? "is-active" : ""}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="quote">
            <path
              fill="var(--Grey7)"
              d="M7 7v7H0V6.9c0-4.8 4.5-5.4 4.5-5.4l.6 1.4s-2 .3-2.4 1.9C2.3 6 3.1 7 3.1 7H7zM16 7v7H9V6.9c0-4.8 4.5-5.4 4.5-5.4l.6 1.4s-2 .3-2.4 1.9c-.4 1.2.4 2.2.4 2.2H16z"
            ></path>
          </svg>
        </button>
      </Tooltip>
      <button onClick={() => editor.chain().focus().setHorizontalRule().run()}>line break</button>
      <Tooltip title="Insert Table">
        <button
          type="button"
          aria-label="Insert Table"
          onClick={() => editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()}
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" id="table">
            <path
              fill="var(--Grey7)"
              d="M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM8,20H4V16H8Zm0-6H4V10H8ZM8,8H4V4H8Zm6,12H10V16h4Zm0-6H10V10h4Zm0-6H10V4h4Zm6,12H16V16h4Zm0-6H16V10h4Zm0-6H16V4h4Z"
            />
          </svg>
        </button>
      </Tooltip>
      <Tooltip title="Insert Image">
        <button type="button" aria-label="Insert Image" onClick={addImage}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" id="image">
            <path
              fill="var(--Grey7)"
              d="M19,2H5A3,3,0,0,0,2,5V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1ZM18.21,8.56l-4.24,4.24-2.12-2.12a2,2,0,0,0-2.83,0L5.71,14H18.29Zm-2.83,1.41,2.12-2.12,2.12,2.12V17H15.38ZM8.12,12.71,10.24,10.6a1,1,0,0,1,1.41,0l4.24,4.24H5.71Z"
            />
          </svg>
        </button>
      </Tooltip>
      <Tooltip title="Undo">
        <span>
          <button onClick={() => editor.chain().focus().undo().run()} disabled={!editor.can().chain().focus().undo().run()}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="corner-up-left-alt" width={24} height={24}>
              <path
                fill="var(--Grey7)"
                d="M17,9.5H7.41l1.3-1.29A1,1,0,0,0,7.29,6.79l-3,3a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l3,3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L7.41,11.5H17a1,1,0,0,1,1,1v4a1,1,0,0,0,2,0v-4A3,3,0,0,0,17,9.5Z"
              ></path>
            </svg>
          </button>
        </span>
      </Tooltip>
      <Tooltip title="Redo">
        <span>
          <button onClick={() => editor.chain().focus().redo().run()} disabled={!editor.can().chain().focus().redo().run()}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="corner-up-right-alt" width={24} height={24}>
              <path
                fill="var(--Grey7)"
                d="M19.92,10.12a1,1,0,0,0-.21-.33l-3-3a1,1,0,1,0-1.42,1.42l1.3,1.29H7a3,3,0,0,0-3,3v4a1,1,0,0,0,2,0v-4a1,1,0,0,1,1-1h9.59l-1.3,1.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l3-3a1,1,0,0,0,.21-.33A1,1,0,0,0,19.92,10.12Z"
              ></path>
            </svg>
          </button>
        </span>
      </Tooltip>

    </BubbleMenu>
  );
};

export default CustomBubbleMenu;
